import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator.jsx";
import DatasourceBaseTextFields from "./DatasourceBaseTextFields.jsx";

const DatasourceTasTms = (props) => {

    const Fields = [
        {Identifier:"Username", Translation:Translate("Username"), Required:true},
        {Identifier:"Password", Translation:Translate("Password"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceTasTms.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceTasTms